import React, { useState } from "react";
import { StyleSheet, View } from "react-native";

import ActionButton from "../common/ActionsMenuButton/ActionButton";
import { buttonStyle } from "../common/ActionsMenuButton/utils";
import AppTheme from "../AppTheme";
import OperationIcon from "../common/ActionsMenuButton/icons/OperationIcon";

export default function AutoTrackFabButton({
  refresh = () => {},
  viewManualMode = () => {},
  mariOptions = {},
  style = {},
}) {
  const [actionButton, setActionButton] = useState(null);

  return (
    <View
      style={[
        buttonStyle,
        style,
        mariOptions.mariMessage ? { zIndex: 1000 } : {},
      ]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      <ActionButton
        mariOptions={mariOptions}
        ref={(r) => setActionButton(r)}
        buttonColor={AppTheme.DEFAULT_COLOR}
        zIndex={999}
        source={"TrakFabButton"}
        buttonTextStyle={styles.mainButton}
      >
        <ActionButton.Item
          hideShadow
          key={3}
          buttonColor="#FFF"
          title="Refresh"
          onPress={refresh}
        >
          <OperationIcon />
        </ActionButton.Item>
        ,
        <ActionButton.Item
          hideShadow
          key={3}
          buttonColor="#FFF"
          title="View Manual Mode"
          onPress={viewManualMode}
        >
          <OperationIcon />
        </ActionButton.Item>
        ,
      </ActionButton>
    </View>
  );
}

const styles = StyleSheet.create({
  actionButtonIcon: {
    height: 23,
    width: 23,
  },
});
